export enum StatusCartEnum {
	Pending = 1,
	Answered = 2,
	Cart = 3,
}
